import React, { useState } from 'react';
import CollectionObjectDropdown from '../../../components/tableMaster/tableView/CollectionObjectDropdown';

export default function CollectionObjectField({ value, onChange, mode, options = [], config, field, ...props }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const { listAttribute } = config || {};
    
    if (mode === "view") {
        return (
            <div>
                <span>{value}</span>
                {value && (
                    <button 
                        type="button" 
                        className="btn btn-sm btn-outline-secondary ms-2"
                        onClick={() => setIsExpanded(!isExpanded)}
                    >
                        {isExpanded ? "Hide Details" : "Show Details"}
                    </button>
                )}
                {isExpanded && value && (
                    <div className="mt-2 p-2 bg-light border rounded">
                        <small className="text-muted">Collection Object ID: {value}</small>
                    </div>
                )}
            </div>
        );
    }

    // Handle list of collection objects
    if (listAttribute) {
        return (
            <div className="collection-object-list-container">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="text-muted">Collection Object List</span>
                    <button 
                        type="button" 
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => {
                            const currentArray = Array.isArray(value) ? value : [];
                            onChange([...currentArray, {}]);
                        }}
                    >
                        + Add Item
                    </button>
                </div>
                
                {(Array.isArray(value) ? value : [{}]).map((item, itemIndex) => (
                    <div key={itemIndex} className="border rounded p-3 mb-3 bg-white">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h6 className="mb-0">Item {itemIndex + 1}</h6>
                            {(Array.isArray(value) ? value : []).length > 1 && (
                                <button 
                                    type="button" 
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => {
                                        const currentArray = Array.isArray(value) ? value : [];
                                        const newArray = currentArray.filter((_, index) => index !== itemIndex);
                                        onChange(newArray);
                                    }}
                                >
                                    Remove Item
                                </button>
                            )}
                        </div>
                        
                        <CollectionObjectDropdown
                            field={field}
                            name={`${field?.name || 'collection'}_${itemIndex}`}
                            value={item}
                            onChange={(event) => {
                                const actualValue = event?.target?.value || event;
                                const currentArray = Array.isArray(value) ? value : [];
                                const newArray = [...currentArray];
                                newArray[itemIndex] = actualValue;
                                onChange(newArray);
                            }}
                        />
                    </div>
                ))}
            </div>
        );
    }
    
    // Handle single collection object
    return (
        <CollectionObjectDropdown
            field={field}
            name={field?.name || 'collection'}
            value={value}
            onChange={onChange}
        />
    );
} 